import React from 'react'

function OperationDash() {
  return (
    <div>OperationDash</div>
  )
}

export default OperationDash